import DeviceManager from '../utils/device-manager';

type OfferStickyNavType = {
    desktopInitialized: boolean,
    $stickyNav: HTMLElement|null,
    $stickyNavAnchors: NodeListOf<HTMLAnchorElement>|null,
    observer: IntersectionObserver|null,
    init(): void,
    initDesktop(): void,
    destroyDesktop(): void,
    onScroll(): void,
};

const OfferStickyNav: OfferStickyNavType = {
    desktopInitialized: false,
    $stickyNav: null,
    $stickyNavAnchors: null,
    observer: null,

    init() : void {
        DeviceManager.addCallback(attr => {
            if (!this.desktopInitialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initDesktop();
            } else if (this.desktopInitialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.destroyDesktop();
            }
        });
    },

    initDesktop() : void {
        this.desktopInitialized = true;

        this.$stickyNav = document.querySelector('.nav-offer-sticky');
        
        if (this.$stickyNav) {
            this.$stickyNavAnchors = this.$stickyNav.querySelectorAll('a[href^="#"]');

            this.observer = new IntersectionObserver(entries => {
                const $anchor = document.querySelector<HTMLAnchorElement>(`a[href="#${entries[0].target.getAttribute('id')}"]`);

                if (entries[0].intersectionRatio > 0.2) {
                    $anchor?.classList.add('active');
                } else {
                    $anchor?.classList.remove('active');
                }
            }, { threshold: 0.2 });
            
            window.addEventListener('scroll', this.onScroll);
            this.onScroll();
            this.$stickyNavAnchors.forEach($anchor => {
                const $element = document.querySelector<HTMLElement>($anchor.getAttribute('href') as string);
                if ($element && this.observer) {
                    this.observer.observe($element);
                }
            });
        }
    },

    destroyDesktop() : void {
        this.desktopInitialized = false;
        
        window.removeEventListener('scroll', this.onScroll);
        if (this.$stickyNavAnchors instanceof NodeList) {
            this.$stickyNavAnchors.forEach($anchor => {
                const $element = document.querySelector($anchor.getAttribute('href') as string);
                if ($element && this.observer) {
                    this.observer.unobserve($element);
                }
            });
        }
    },

    onScroll() : void {
        const $stickyNav = document.querySelector<HTMLElement>('.nav-offer-sticky');
        const scroll = window.scrollY;

        if (scroll > 200) {
            $stickyNav?.classList.add('scrolled');
        } else {
            $stickyNav?.classList.remove('scrolled');
        }
    },
};

export default OfferStickyNav;
